import {createRouter, createWebHistory} from 'vue-router'
import BaseLayout from '@/views/Layout.vue'

const routes = [
    {
        path: '/admin',
        component: BaseLayout,
        children: [
            {
                path: '/',
                component: () => import('../views/User.vue')
            },
            {
                path: 'patient',
                name: 'patient',
                component: () => import('../views/patient.vue')
            },
            {
                path: '',
                name: 'User',
                component: () => import('../views/User.vue')
            },
            {
                path: 'user',
                name: 'User',
                component: () => import('../views/User.vue')
            },
            {
                path: 'appointment',
                name: 'appointment',
                component: () => import('../views/Appointment.vue')
            },
            {
                path: 'feedback',
                name: 'feedback',
                component: () => import('../views/Feedback.vue')
            },
            {
                path: 'coupons',
                name: 'coupons',
                component: () => import('../views/Coupons.vue')
            },
            {
                path: 'notice',
                name: 'notice',
                component: () => import('../views/Notice.vue')
            },
            {
                path: 'institution',
                name: 'institution',
                component: () => import('../views/Institution.vue')
            },
            {
                path: 'device',
                name: 'device',
                component: () => import('../views/device.vue')
            },
            {
                path: 'other',
                name: 'other',
                component: () => import('../views/Other.vue')
            },
            {
                path: 'timePeriod',
                name: 'timePeriod',
                component: () => import('../views/TimePeriod.vue')
            },
            {
                path: 'refundRecord',
                name: 'refundRecord',
                component: () => import('../views/refundRecord/refundRecord.vue')
            },
            {
                path: 'appointmentstatistics',
                name: 'appointmentstatistics',
                component: () => import('../views/Appointment/AppointmentStatistics.vue')
            },
            {
                path: 'scanQRCodeRecord',
                name: 'scanQRCodeRecord',
                component: () => import('../views/ScanQRCodeRecord/ScanQRCodeRecord.vue')
            },
            {
                path: 'admin',
                name: 'admin',
                component: () => import('../views/admin/adminIndex.vue')
            },
            // 其他子路由...
        ],
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path:
            '/institution',
        component: BaseLayout,
        children: [
            {
                path: '/',
                component: () => import('../views/ScanQRCodeRecord/ScanQRCodeRecord.vue')
            },
            {
                path: 'UserI',
                name: 'UserI',
                component: () => import('../views/User.vue')
            },
            {
                path: 'patientI',
                name: 'patientI',
                component: () => import('../views/patient.vue')
            },
            {
                path: 'appointmentI',
                name: 'appointmentI',
                component: () => import('../views/Appointment.vue')
            },
            {
                path: 'scanQRCodeRecordI',
                name: 'scanQRCodeRecordI',
                component: () => import('../views/ScanQRCodeRecord/ScanQRCodeRecord.vue')
            },
            {
                path: 'deviceI',
                name: 'deviceI',
                component: () => import('../views/device.vue')
            },
        ],
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
